<countdown-timer [countDownTimerConfig]="timerConfig"></countdown-timer>
